export default __webpack_public_path__ + "cc189a0fbb63edb734cd80cf7d05111e.png";